export const buildCatalystInsightsListPayload = (
  themeId: string,
  minDate: Date | undefined,
  maxDate: Date | undefined
) => ({
  themes: [themeId],
  ...(minDate && maxDate
    ? { from: minDate.toISOString(), to: maxDate.toISOString() }
    : {}),
});

export const shouldShowBandChartInsights = ({
  isCatalystInsightsLoading,
  catalystInsights,
  minDate,
  maxDate,
  tsDataLength,
}: {
  isCatalystInsightsLoading: boolean;
  catalystInsights: { length: number } | undefined;
  minDate: Date | undefined;
  maxDate: Date | undefined;
  tsDataLength: number;
}) =>
  !isCatalystInsightsLoading &&
  (catalystInsights?.length ?? 0) > 0 &&
  !!minDate &&
  !!maxDate &&
  tsDataLength > 0;
